module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "loading": _vm.requests.configure.loading,
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Configure Physitrack\n    "), _c('v-spacer'), _vm._v(" "), (_vm.requests.test.status === 200) ? _c('v-chip', {
    attrs: {
      "small": "",
      "color": "success",
      "dark": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check_circle")])], 1), _vm._v("\n      Connected\n    ")], 1) : (_vm.requests.test.status >= 400) ? _c('v-chip', {
    attrs: {
      "small": "",
      "color": "error",
      "dark": ""
    },
    on: {
      "click": _vm.testConnection
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")])], 1), _vm._v("\n      Connection error\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.test.loading,
      "disabled": _vm.configureRequestStatus !== 200,
      "small": ""
    },
    on: {
      "click": _vm.testConnection
    }
  }, [_vm._v("Test connection")])], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.configure,
      "message204": "Successfully uninstalled",
      "message404": "Currently not installed",
      "message201": "Integration installed successfully"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.agToken) ? _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "color": "warning",
      "outline": "",
      "card": "",
      "value": true,
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Discount code:")]), _vm._v(" "), _c('code', [_vm._v("AGPT2020")]), _c('br'), _vm._v("\n        You can use this discount code to get a 20% discount off your monthly Physitrack subscription"), _c('br'), _vm._v("\n        You can enter the code in Physitrack: account -> subscription\n      ")]) : _vm._e(), _vm._v(" "), (_vm.agToken) ? _c('v-alert', {
    attrs: {
      "type": "info",
      "value": true,
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline pl-0",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("Your AppointmentGuru API Key")]), _vm._v(" "), _c('copy-text-field', {
    attrs: {
      "dark": "",
      "label": "Your AppointmentGuru API key",
      "text-to-copy": _vm.agToken
    }
  }), _vm._v(" "), _c('small', [_c('strong', [_vm._v("In Physitrack")]), _vm._v(", account -> settings under the "), _c('strong', [_vm._v("Integrations")]), _vm._v("\n          heading:\n          "), _c('ol', [_c('li', [_vm._v("\"Synchronize my client data from:\" Choose AppointmentGuru")]), _vm._v(" "), _c('li', [_vm._v("Paste the key above for the API key")])]), _vm._v("\n          Once you've done this, click "), _c('strong', [_vm._v("test connection")]), _vm._v(" to verify that the integration is properly installed\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.formErrors.service_user_id,
      "label": "Your physitrack token"
    },
    model: {
      value: (_vm.physitrackToken),
      callback: function($$v) {
        _vm.physitrackToken = $$v
      },
      expression: "physitrackToken"
    }
  }), _vm._v(" "), _c('small', [_c('strong', [_vm._v("In Physitrack")]), _vm._v(", account -> settings under the "), _c('strong', [_vm._v("API")]), _vm._v(" heading\n          Make sure \"Enable API access to my account\" is selected and paste the API key here."), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Tip:")]), _vm._v(" Your API key will look something like this:\n          "), _c('code', [_vm._v("bb4a74001fde53c1d3847687462fb070d57eddbd0e31343f66a93c0d429a5669")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Physitrack url (datacenter)",
      "prefix": "https://",
      "suffix": "physitrack.com"
    },
    model: {
      value: (_vm.datacenter),
      callback: function($$v) {
        _vm.datacenter = $$v
      },
      expression: "datacenter"
    }
  }), _vm._v(" "), _c('small', [_vm._v("\n          When you are logged in to Physitrack and you look at the URL, what do you see just before `physitrack.com`.\n          If nothing (e.g.: your url is https://physitrack.com) use "), _c('strong', [_vm._v("us")]), _c('br'), _vm._v("\n          Common options are: "), _c('strong', [_vm._v("us")]), _vm._v(", "), _c('strong', [_vm._v("uk")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-4"
  }, [_c('v-dialog', {
    attrs: {
      "width": 320
    },
    model: {
      value: (_vm.showuninstall),
      callback: function($$v) {
        _vm.showuninstall = $$v
      },
      expression: "showuninstall"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n            Are you sure you want to unintsall the Physitrack integration?\n          ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showuninstall = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "error"
    },
    on: {
      "click": _vm.uninstall
    }
  }, [_vm._v("\n              Uninstall Physitrack\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.showuninstall = true
      }
    }
  }, [_vm._v("\n        Uninstall")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.configure.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.configure
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5143a72d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/index.vue
// module id = 1659
// module chunks = 7